import { render, staticRenderFns } from "./VillageArchDiagram.vue?vue&type=template&id=f5de609a&scoped=true"
import script from "./VillageArchDiagram.vue?vue&type=script&lang=js"
export * from "./VillageArchDiagram.vue?vue&type=script&lang=js"
import style0 from "./VillageArchDiagram.vue?vue&type=style&index=0&id=f5de609a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5de609a",
  null
  
)

export default component.exports